/**
 * Toggles this.loading while the wrapped method is running.
 * Only works on methods that always return a Promise.
 *
 * @returns {(target, propertyKey: string, descriptor: PropertyDescriptor) => PropertyDescriptor}
 */
export function toggleLoading(loadingProperty: string = "loading") {
  return function toggleLoadingDecorator(target, propertyKey: string, descriptor: PropertyDescriptor) {
    if (descriptor === undefined) {
      descriptor = Object.getOwnPropertyDescriptor(target, propertyKey);
    }

    const original = descriptor.value; // warning: this === undefined

    descriptor.value = function (...args) { // eslint-disable-line func-names
      const self = this;
      const oldMethod = original.bind(self);
      let result;

      return (async () => {
        try {
          self[loadingProperty] = true;
          result = await oldMethod(...args);
        } finally {
          self[loadingProperty] = false;
        }

        return result;
      })();
    };

    return descriptor;
  };
}
